const normalizeStatus = (value) => String(value || '').trim().toLowerCase();

const parseMoney = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(String(value).replace(/[^0-9.-]/g, ''));
  return Number.isFinite(parsed) ? parsed : null;
};

const firstValue = (record, ...keys) => {
  for (const key of keys) {
    if (record?.[key] !== null && record?.[key] !== undefined && record?.[key] !== '') {
      return record[key];
    }
  }
  return null;
};

const hasExactWalletDelta = (recharge) => {
  const amount = parseMoney(recharge?.amount);
  const balanceBefore = parseMoney(firstValue(recharge, 'balanceBefore', 'balance_before'));
  const balanceAfter = parseMoney(firstValue(recharge, 'balanceAfter', 'balance_after'));
  if (amount === null || amount <= 0 || balanceBefore === null || balanceAfter === null) return false;
  return Math.abs((balanceAfter - balanceBefore) - amount) <= 0.01;
};

export const getRechargeCreditPresentation = (recharge = {}) => {
  const paymentStatus = normalizeStatus(firstValue(recharge, 'status', 'payment_status', 'paymentStatus'));
  const creditStatus = normalizeStatus(firstValue(recharge, 'creditStatus', 'credit_status'));
  const providerDisplayStatus = normalizeStatus(recharge.displayStatus);
  const explicitWalletCredited = typeof recharge.walletCredited === 'boolean'
    ? recharge.walletCredited
    : null;
  const paymentCompleted = ['completed', 'success', 'successful', 'paid'].includes(paymentStatus);
  const paymentPending = ['pending', 'processing', 'created'].includes(paymentStatus);
  const paymentFailed = ['failed', 'cancelled', 'canceled', 'expired'].includes(paymentStatus);
  const creditedByStatus = ['credited', 'success', 'successful', 'completed'].includes(creditStatus);
  const walletCredited = explicitWalletCredited === true || creditedByStatus || hasExactWalletDelta(recharge);

  if (walletCredited) {
    return {
      state: 'credited',
      needsAttention: false,
      tone: 'success',
      displayStatus: paymentCompleted ? firstValue(recharge, 'status') : 'Completed'
    };
  }

  if (paymentFailed) {
    return {
      state: 'payment_failed',
      needsAttention: false,
      tone: 'danger',
      displayStatus: firstValue(recharge, 'status', 'displayStatus') || 'Failed'
    };
  }

  if (paymentPending) {
    return {
      state: 'payment_pending',
      needsAttention: false,
      tone: 'warning',
      displayStatus: firstValue(recharge, 'status', 'displayStatus') || 'Pending'
    };
  }

  const creditRejected = ['pending', 'failed', 'error', 'not_credited', 'not credited'].includes(creditStatus);
  const staleNotCreditedLabel = providerDisplayStatus.includes('not credited');
  if (paymentCompleted && (explicitWalletCredited === false || creditRejected || staleNotCreditedLabel)) {
    return {
      state: 'paid_not_credited',
      needsAttention: true,
      tone: 'warning',
      displayStatus: recharge.displayStatus || 'Paid, wallet not credited'
    };
  }

  if (paymentCompleted) {
    return {
      state: 'credited',
      needsAttention: false,
      tone: 'success',
      displayStatus: firstValue(recharge, 'status') || 'Completed'
    };
  }

  return {
    state: 'unknown',
    needsAttention: false,
    tone: 'neutral',
    displayStatus: firstValue(recharge, 'displayStatus', 'status') || 'N/A'
  };
};
